import * as React from 'react';
import {
    Controller,
    Menu,
    Toolbar,
    CustomArgs,
    ActionPointInfo,
    IActionPointInfo,
} from '@tencent/workbench';
import { HorizontalAlignFeature } from './horizontal-align-feature';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import {
    horizontalCenter, horizontalJustify,
    horizontalDistribute,
    horizontalLeft,
    horizontalRight,
} from '@editor/src/js/constants/toolbar-data';
import { Form } from '@tencent/wb-ext-form';
import { FORM_CONFIGS_H_ALIGN } from '@framework/workbench/drawer/ui/text/paragraph/config';
import {
    AlignType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

/**
 * 水平对齐
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
    formItems: FORM_CONFIGS_H_ALIGN,
})
export class HorizontalAlignController {
    constructor(private readonly feature: HorizontalAlignFeature) {
    }

    /**
     * 单栏，对齐操作被收到面板中
     */
    @Toolbar(config.id, 'dropdownContent')
    public showContent() {
        return this.feature.showContent(true);
    }

    @Toolbar(horizontalLeft.id, 'onClick')
    @Toolbar(horizontalCenter.id, 'onClick')
    @Toolbar(horizontalRight.id, 'onClick')
    @Toolbar(horizontalJustify.id, 'onClick')
    @Toolbar(horizontalDistribute.id, 'onClick')
    public onClick(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        this.feature.callbackByActionType(name, name);
    }

    @Toolbar(config.id, 'icon')
    public getToolbarIcon() {
        const icon = this.feature.getSelectedIcon();
        return <img src={icon || config.icon} alt={''}/>;
    }

    @Menu(AlignType.HORIZONTAL_LEFT, 'onClick', { horizontal: AlignType.HORIZONTAL_LEFT })
    @Menu(AlignType.HORIZONTAL_CENTER, 'onClick', { horizontal: AlignType.HORIZONTAL_CENTER })
    @Menu(AlignType.HORIZONTAL_RIGHT, 'onClick', { horizontal: AlignType.HORIZONTAL_RIGHT })
    @Menu(AlignType.HORIZONTAL_JUSTIFY, 'onClick', { horizontal: AlignType.HORIZONTAL_JUSTIFY })
    @Menu(AlignType.HORIZONTAL_DISTRIBUTE, 'onClick', { horizontal: AlignType.HORIZONTAL_DISTRIBUTE })
    public handleClick(@CustomArgs() args: { horizontal: string }) {
        this.feature.callback(args.horizontal);
    }

    @Menu(AlignType.HORIZONTAL_LEFT, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_LEFT })
    @Menu(AlignType.HORIZONTAL_CENTER, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_CENTER })
    @Menu(AlignType.HORIZONTAL_RIGHT, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_RIGHT })
    @Menu(AlignType.HORIZONTAL_JUSTIFY, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_JUSTIFY })
    @Menu(AlignType.HORIZONTAL_DISTRIBUTE, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_DISTRIBUTE })
    @Toolbar(AlignType.HORIZONTAL_LEFT, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_LEFT })
    @Toolbar(AlignType.HORIZONTAL_CENTER, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_CENTER })
    @Toolbar(AlignType.HORIZONTAL_RIGHT, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_RIGHT })
    @Toolbar(AlignType.HORIZONTAL_JUSTIFY, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_JUSTIFY })
    @Toolbar(AlignType.HORIZONTAL_DISTRIBUTE, 'shouldCheck', { horizontal: AlignType.HORIZONTAL_DISTRIBUTE })
    @Form(AlignType.HORIZONTAL_LEFT, 'value', { horizontal: AlignType.HORIZONTAL_LEFT })
    @Form(AlignType.HORIZONTAL_CENTER, 'value', { horizontal: AlignType.HORIZONTAL_CENTER })
    @Form(AlignType.HORIZONTAL_RIGHT, 'value', { horizontal: AlignType.HORIZONTAL_RIGHT })
    @Form(AlignType.HORIZONTAL_JUSTIFY, 'value', { horizontal: AlignType.HORIZONTAL_JUSTIFY })
    @Form(AlignType.HORIZONTAL_DISTRIBUTE, 'value', { horizontal: AlignType.HORIZONTAL_DISTRIBUTE })
    public shouldCheck(@CustomArgs() args: { horizontal: string }) {
        return this.feature.getItemValue() === args.horizontal;
    }

    @Form(AlignType.HORIZONTAL_LEFT, 'onClick', { horizontal: AlignType.HORIZONTAL_LEFT })
    @Form(AlignType.HORIZONTAL_CENTER, 'onClick', { horizontal: AlignType.HORIZONTAL_CENTER })
    @Form(AlignType.HORIZONTAL_RIGHT, 'onClick', { horizontal: AlignType.HORIZONTAL_RIGHT })
    @Form(AlignType.HORIZONTAL_JUSTIFY, 'onClick', { horizontal: AlignType.HORIZONTAL_JUSTIFY })
    @Form(AlignType.HORIZONTAL_DISTRIBUTE, 'onClick', { horizontal: AlignType.HORIZONTAL_DISTRIBUTE })
    public handleDrawerClick(@CustomArgs() args: { horizontal: string }) {
        this.feature.drawerCallback(args.horizontal);
    }
}
